export default {
  headers: {
    // Common headers
    result: "Резултат",
    results: "Резултати",
    current: "Текущ",
    test: "Тест",
    flagText: "Флаг",
    flags: "Флагове",
    refRange: "Реф. граници",
    units: "Единици",
    resultTime: "Дата / Час",
    history: "История",
    actions: "Действия",
    visit_id: "Визита",
    barcode: "Баркод",
    total_results: "Резултати",
    instrument: "Апарат",
    disk_rack: "Рафт/Статив",
    position: "Позиция",
    sample_number: "№ на проба",
    sample_type: "Тип проба",
    sets_count: "Серии",
    pending_results: "Чакащи",
    approved_results: "Одобрени",
  },

  no_data: "Няма налични данни",
  items_per_page: "Елементи на страница:",
  all: "Всички",
  clearFilters: "Изчисти филтрите",
  unknown_location: "Неизвестна локация",

  toolbar: {
    refresh: "Обновяване на резултати",
    email: "Изпрати по имейл",
    emailAction: "Имейл",
    pdf: "Изтегли PDF",
    pdfAction: "PDF",
  },
};
